import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	CircularProgress,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { MOBILE_BREAKPOINT, DIALOG_SETTINGS, FULLSCREEN_DIALOG_PAPER_SX, FULLSCREEN_DIALOG_CONTENT_SX } from '../../utils/responsive';

interface DeleteConfirmDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message: string;
	isLoading?: boolean;
}

export default function DeleteConfirmDialog({
	open,
	onClose,
	onConfirm,
	title,
	message,
	isLoading = false,
}: DeleteConfirmDialogProps) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down(MOBILE_BREAKPOINT));

	return (
		<Dialog
			open={open}
			onClose={!isLoading ? onClose : undefined}
			maxWidth={DIALOG_SETTINGS.CONFIRM.MAX_WIDTH}
			fullWidth
			fullScreen={isMobile}
			PaperProps={{
				sx: {
					...(isMobile ? FULLSCREEN_DIALOG_PAPER_SX : { p: DIALOG_SETTINGS.TABLET_PADDING }),
				},
			}}
		>
			<DialogTitle sx={{ flexShrink: 0 }}>{title}</DialogTitle>
			<DialogContent sx={isMobile ? FULLSCREEN_DIALOG_CONTENT_SX : undefined}>
				<Typography>{message}</Typography>
			</DialogContent>
			<DialogActions sx={{ flexShrink: 0, borderTop: isMobile ? 1 : 0, borderColor: 'divider', p: isMobile ? 2 : undefined }}>
				<Button onClick={onClose} disabled={isLoading}>
					Hủy
				</Button>
				<Button
					onClick={onConfirm}
					variant="contained"
					color="error"
					disabled={isLoading}
					startIcon={isLoading ? <CircularProgress size={20} /> : null}
				>
					Xóa
				</Button>
			</DialogActions>
		</Dialog>
	);
}